<!--
 * @Author: zhouhx
 * @Date: 2024-02-27 14:22:54
 * @LastEditors: zhouhx
 * @LastEditTime: 2024-03-01 10:57:03
 * @Description: 新建转诊
-->
<template>
  <div class="coverFooter create-index">
    <van-nav-bar :title="title" left-arrow>
      <template #left>
        <div @click="back()">
          <i class="iconfont iconbtn_24_back"></i>
        </div>
      </template>
    </van-nav-bar>

    <div class="infoheader form-group">
      <div class="form-line clearfix" v-for="(d, i) in formData" :key="i">
        <van-field :required="d.required" v-if="d.type === 'select'" v-model="d.code" is-link readonly :label="d.title"
          placeholder="请选择" @click="changePopup(d)" />
        <van-cell-group inset v-if="d.type === 'textarea'">
          <van-field :required="d.required" v-model="d.code" rows="1" autosize :label="d.title" type="textarea"
            :placeholder="'请输入' + d.title" />
        </van-cell-group>
      </div>
      <div class="form-line clearfix" style="padding: 0">
        <button type="button" @click="submitBtn">{{ btnName }}</button>
      </div>
      <van-popup v-model="model.status" position="bottom" :style="{ height: 'auto' }">
        <ul>
          <li :class="{ activeLi: item.seledted }" v-for="(item, key) in model.columns" :key="key"
            @click="onChange(item)">
            {{ item.text }}
          </li>
        </ul>
      </van-popup>
      <van-popup v-model="datesetting.status" position="bottom" :style="{ height: 'auto' }" closeable>
        <datediv ref="eTime" v-if="model.title === 'expectationTime'" :search="this.submitData" @getTime="getTime">
        </datediv>
        <addexpertdiv v-else ref="addexpert" :search="this.submitData" @submitExpert="submitExpert"></addexpertdiv>
      </van-popup>
    </div>
  </div>
</template>
<script>
const datediv = () => import('./index/date-setting.vue')
const addexpertdiv = () => import('./index/add-expert.vue')
export default {
  components: {
    datediv,
    addexpertdiv
  },
  data () {
    return {
      referralId: Number(this.$route.query.dataid),
      bk: Number(this.$route.query.bk),
      edit: Number(this.$route.query.edit),
      re_searchParams: {},
      orgData: [],
      dptData: [],
      model: {
        status: false,
        columns: [],
        title: ''
      },
      datesetting: {
        status: false
      },
      formData: [
        {
          required: true,
          title: '上转业务',
          id: 'referralBusiness',
          options: [{
            parentId: 'referralBusiness',
            value: 1,
            text: '门诊',
            seledted: 0
          },
          {
            parentId: 'referralBusiness',
            value: 2,
            text: '住院',
            seledted: 0
          },
          {
            parentId: 'referralBusiness',
            value: 3,
            text: '检查',
            seledted: 0
          }],
          code: '',
          type: 'select'
        },
        { required: true, title: '转入机构', id: 'receiveOrganizationId', options: [], code: '', type: 'select' },
        { required: true, title: '就诊科室', id: 'receiveDepartmentId', options: [], code: '', type: 'select' },
        { required: false, title: '接诊医生', id: 'receiveUserId', options: [], code: '', type: 'select' },
        { required: false, title: '转诊时间', id: 'expectationTime', options: [], code: '', type: 'select' },
        { required: true, title: '转诊目的', id: 'reason', options: [], code: '', type: 'textarea' },
        {
          required: true,
          title: '获取方式',
          id: 'caseSelectMode',
          options: [
            {
              parentId: 'caseSelectMode',
              value: 1,
              text: '历史病例',
              seledted: 1
            }
          ],
          code: '历史病例',
          type: 'select'
        }
      ],
      submitData: {
        caseSelectMode: 1, // 资料获取方式：1选择历史
        expectationTime: '',
        reason: '',
        receiveDepartmentId: 0,
        receiveOrganizationId: 0,
        receiveUserId: 0,
        referralBusiness: 1, // 1、门诊，2、住院，3、检查
        referralDirect: 1, // 转诊方向：1上转，2下转
        sendDepartmentId: Number(this.$store.state.userInfo.departmentId),
        sendOrganizationId: Number(this.$store.state.userInfo.organizationId),
        sendUserId: Number(this.$store.state.userInfo.id),
        platformId: Number(this.$store.state.systemInfo.id)
      },
      activeInfo: {},
      referralInfo: {},
      btnName: '',
      title: ''
    }
  },
  created () {
    this.re_searchParams = JSON.parse(localStorage.getItem('re_searchParams'))
    this.submitData.referralDirect = this.re_searchParams.referralDirect
    let businessName;
    if (this.submitData.referralDirect === 2) {
      businessName = '下转业务'
    } else {
      businessName = '上转业务'
    }
    this.formData.find(e => e.id === 'referralBusiness').title = businessName
    // 编辑
    if (this.edit) {
      this.formData.pop()
      this.btnName = '提交'
      this.title = '编辑转诊详情'
      this.getInfo()
    } else if (this.bk) {
      this.btnName = '下一步'
      this.title = '新建转诊申请'
      this.getInfo()
    } else {
      this.btnName = '下一步'
      this.title = '新建转诊申请'
      this.orgList()
    }
  },
  methods: {
    changePopup (data) {
      this.model.title = data.id
      switch (data.id) {
        case 'referralBusiness':
          this.model.status = true
          this.model.columns = this.formData[0].options;
          break;
        case 'receiveOrganizationId':
          this.model.status = true
          this.model.columns = this.orgData;
          break
        case 'receiveDepartmentId':
          if (!this.submitData.receiveOrganizationId) {
            this.$toast('请先选择转入机构');
            return
          }
          this.model.status = true
          this.model.columns = this.dptData
          break;
        case 'expectationTime':
          this.datesetting.status = true;
          this.model.title = 'expectationTime'
          setTimeout(() => {
            this.$refs.eTime.getTimeData()
          }, 200);
          break;
        case 'receiveUserId':
          if (!this.submitData.receiveDepartmentId) {
            this.$toast('请先选择就诊科室');
            return
          }
          this.datesetting.status = true;
          this.model.title = 'receiveUserId'
          setTimeout(() => {
            this.$refs.addexpert.expertList()
          }, 200);
          break;
        case 'caseSelectMode':
          this.model.status = true;
          this.model.title = 'caseSelectMode'
          break;
        default:
          this.model.columns = []
          break
      }
    },
    getInfo () {
      this.$axios
        .post('api/dual/referral/get', {
          data: { referralId: this.referralId },
          version: this.$version
        })
        .then((res) => {
          if (res.status) {
            this.referralInfo = res.data
            this.submitData.referralBusiness = this.referralInfo.referralBusinessCode
            this.formData.find(e => e.id === 'referralBusiness').code = this.referralInfo.referralBusiness
            this.formData.find(e => e.id === 'referralBusiness').options.forEach(d => {
              if (d.value === this.referralInfo.referralBusinessCode) {
                d.seledted = 1
              }
            });
            this.submitData.expectationTime = this.referralInfo.expectationTime
            this.formData.find(e => e.id === 'expectationTime').code = this.referralInfo.expectationTime
            this.submitData.reason = this.referralInfo.reason
            this.formData.find(e => e.id === 'reason').code = this.referralInfo.reason
            this.submitData.receiveUserId = this.referralInfo.referralReceiveExpertId
            this.formData.find(e => e.id === 'receiveUserId').code = this.referralInfo.referralReceiveExpertName
            this.orgList()
          }
        })
    },
    orgList (value) {
      if (value) {
        this.orgData.forEach(e => {
          e.seledted = 0
          if (this.submitData.receiveOrganizationId === e.id) {
            e.seledted = 1
            this.formData.find(e => e.id === 'receiveOrganizationId').code = e.organizationName
          }
        });
        this.dptList(1)
        return
      }
      this.$axios
        .post('api/dual/referral/org/list', {
          data: {
            referralDirect: this.submitData.referralDirect,
            sendOrganizationId: this.submitData.sendOrganizationId
          },
          version: 0
        })
        .then((res) => {
          if (res.status) {
            res.data.forEach(e => {
              e.parentId = 'receiveOrganizationId'
              e.value = e.id
              e.text = e.organizationName
              e.seledted = 0
              if (this.referralId && (this.referralInfo.referralReceiveOrgId === e.value)) {
                e.seledted = 1
                this.submitData.receiveOrganizationId = e.id
                this.formData.find(e => e.id === 'receiveOrganizationId').code = e.organizationName
              }
            });
            this.orgData = res.data
            if (this.referralId) {
              this.dptList()
            }
          }
        })
    },
    dptList (value) {
      this.dptData = []
      this.$axios
        .post('admin/organization/department/list', {
          data: {
            createOrganizationId: this.submitData.receiveOrganizationId
          },
          version: 0
        })
        .then((res) => {
          if (res.status) {
            res.data.lists.forEach(e => {
              e.parentId = 'receiveDepartmentId'
              e.value = e.id
              e.text = e.departmentName
              e.seledted = 0
              if (!value && this.referralId && (this.referralInfo.referralReceiveDepId === e.value)) {
                e.seledted = 1
                this.submitData.receiveDepartmentId = e.id
                this.formData.find(e => e.id === 'receiveDepartmentId').code = e.departmentName
              }
            });
            this.dptData = res.data.lists
            if (value) {
              this.dptData.forEach(e => {
                e.seledted = 0
                if (this.submitData.receiveDepartmentId === e.id) {
                  e.seledted = 1
                  this.formData.find(e => e.id === 'receiveDepartmentId').code = e.departmentName
                }
              });
              this.submitData.receiveUserId = 0
              this.formData.find(e => e.id === 'receiveUserId').code = ''
            }
          }
        })
    },
    onChange (data) {
      switch (this.model.title) {
        case 'referralBusiness':
          this.submitData.referralBusiness = data.value
          break;
        case 'receiveOrganizationId':
          this.submitData.receiveOrganizationId = data.value
          this.submitData.receiveDepartmentId = 0
          this.formData.find(e => e.id === 'receiveDepartmentId').code = ''
          this.orgList(1)
          break;
        case 'receiveDepartmentId':
          this.submitData.receiveDepartmentId = data.value
          this.submitData.receiveUserId = 0
          this.formData.find(e => e.id === 'receiveUserId').code = ''
          this.dptList(1)
          break;
        case 'expectationTime':
          this.submitData.expectationTime = data.value
          break;
        case 'receiveUserId':
          this.submitData.receiveUserId = data.id
          break;
        case 'caseSelectMode':
          this.submitData.caseSelectMode = data.value
          break;
      }
      this.formData.forEach(e => {
        if (e.id === data.parentId) {
          e.code = data.text
        }
        if (e.options && e.options.length) {
          e.options.forEach(d => {
            d.seledted = 0
            if (d.value === data.value) {
              d.seledted = 1
            }
          });
        }
      });
      this.model.status = false
      this.datesetting.status = false
    },
    getTime (data) {
      data.parentId = 'expectationTime'
      data.text = data.value
      this.model.title = 'expectationTime'
      this.onChange(data)
    },
    submitExpert (data) {
      this.activeInfo = data
      data.parentId = 'receiveUserId'
      data.text = data.trueName
      this.model.title = 'receiveUserId'
      this.onChange(data)
    },
    submitBtn () {
      this.submitData.reason = this.formData.find(e => e.id === 'reason').code
      if (this.submitData.expectationTime && this.submitData.expectationTime.split(':').length === 2) {
        this.submitData.expectationTime = this.submitData.expectationTime + ':00'
      }

      if (!this.submitData.reason || !this.submitData.receiveDepartmentId || !this.submitData.receiveOrganizationId) {
        this.$toast('带星号的为必填项')
        return
      }
      if (!this.submitData.receiveUserId) {
        delete this.submitData.receiveUserId
      }
      if (this.referralId) {
        this.submitData.id = this.referralId
      }
      this.$axios
        .post('api/dual/referral/add', {
          version: this.$version,
          data: this.submitData
        })
        .then((res) => {
          if (res.status) {
            if (this.edit) {
              this.$router.push({
                path: '/re-detail',
                query: { edit: 1, dataid: this.referralId }
              });
              return
            }
            this.$router.push({
              path: '/re-history',
              query: { dataid: res.data }
            })
          }
        })
    },
    // 返回
    back () {
      if (this.ed) {
        this.$router.push({
          path: '/re-detail',
          query: { bk: 1, dataid: this.referralId }
        });
        return
      }
      this.$router.push({
        path: '/index/referral_apply'
      });
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .van-field__control {
  text-align: right !important;
}

.form-line {
  line-height: unset;
  height: auto;
  min-height: 52px;
  max-height: 106px;
  overflow: auto;

  button {
    font-size: 16px;
    height: 52px;
    line-height: 52px;
    background-color: #536cf5;
    text-align: center;
    color: #fff;
    position: fixed;
    bottom: 0;
    width: 100%;
  }
}

ul {
  background-color: $white;
  text-align: center;

  li {
    padding: 15px 0;
  }

  .activeLi {
    color: #536cf5;
  }
}
</style>
